<app-page-heading [key]="'webhooks-events.title'"
                  [subheadingIcon]="'fa fa-truck'"
                  [disableMarginBottom]="true"
                  [carriers]="carriers"
                  [selectedCarrier]="selectedCarrier"
                  (selectedCarrierChange)="onSelectedCarrierChange($event)">
</app-page-heading>

<section class="container-fluid summary-panel space-top-20">
    <div class="alert alert-info light-orange">
        <i class="fa fa-warning warning-icon"></i> <div [i18n]="'webhooks-events.modification.warning'"></div>
    </div>
    <app-tabs *ngIf="selectedCarrier">
        <app-tab [tabTextKey]="'webhooks-events.list.title'" [faIcon]="'fa fa-bell'" [(selected)]="listSelected" [navigate]="goToList">
            <app-webhook-events-list *ngIf="!selectedEventId" [carrier]="selectedCarrier"
                                     (onEventSelection)="selectEvent($event)">
            </app-webhook-events-list>
            <app-webhook-events-details *ngIf="selectedEventId"
                                        [eventId]="selectedEventId"
                                        (onBackSelection)="resetEvent()">
            </app-webhook-events-details>
        </app-tab>

        <app-tab [tabTextKey]="'webhooks-events.subscriptions.title'" [faIcon]="'fa fa-cog'" [(selected)]="configSelected" [navigate]="goToConfig">
            <app-webhook-subscriptions #webhookSubscriptionsComponent
                                       (displayDocumentationEmitter)="displayDocumentation($event)"
                                       [carrier]="selectedCarrier">
            </app-webhook-subscriptions>
        </app-tab>

        <app-tab [tabTextKey]="'webhooks-events.documentation.title'" [faIcon]="'fa fa-file-alt'" [(selected)]="docSelected" [navigate]="goToDoc">
            <app-webhook-documentation [target]="targetInDocumentation"></app-webhook-documentation>
        </app-tab>
    </app-tabs>
</section>
